export default __webpack_public_path__ + "static/media/visa.095272a7.svg";